export default "__VITE_ASSET__DlMnwVXC__"